module.exports = __webpack_public_path__ + "static/img/jigou-tianjin-top.1d256dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-tianjin-top.png
// module id = ZAgL
// module chunks = 2